import { sortBy } from 'lodash';
import { RootState } from '..';

export const selectParameters = (state: RootState) =>
  sortBy(state.parameters.parameters, 'name');

export const selectActiveParameters = (state: RootState) =>
  sortBy(
    state.parameters.parameters.filter(x => x.active),
    'name'
  );

export const selectParameterErrors = (state: RootState) =>
  state.parameters.errors;
